import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router/composables'

import Card from '../../../../components/ui/Card.vue'
import ContentBody from '../../../../components/ui/ContentBody.vue'
import ContentHeader from '../../../../components/ui/ContentHeader.vue'
import Breadcrumb from '../../../../components/ui/breadcrumb/Breadcrumb.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExclusionZone.layout',
  setup(__props) {

const { getCrumbs } = useLayoutCrud()

const step = ref(getCrumbs().length - 1)

function useLayoutCrud() {
	const { currentRoute } = useRouter()
	const { name } = currentRoute

	function getCrumbs() {
		const pathArray = (useRouter().currentRoute.meta!.breadcrumb as string)
			.split('/')
			.filter((crumb) => crumb != '')

		return pathArray.map((crumb, index) => {
			return {
				name: crumb,
				step: index,
			}
		})
	}

	return { getCrumbs, name }
}

return { __sfc: true,getCrumbs, step, useLayoutCrud, Card, ContentBody, ContentHeader, Breadcrumb }
}

})